const PERMISSIONS_TIERS = {
  PUBLIC: 'PUBLIC',
  FRIENDS: 'FRIENDS',
  EVERY_HOUSE: 'EVERY_HOUSE',
  LOCAL_HOUSE: 'LOCAL_HOUSE',
  EVERY_PLUS_HOUSE: 'EVERY_PLUS_HOUSE',
  HOUSE: 'HOUSE'
}

export const ALL_TIERS = Object.values(PERMISSIONS_TIERS)

export default PERMISSIONS_TIERS
